import { Routes, Route } from "react-router-dom";
import Login from "./pages/login/login";
import Dashboard from "./pages/dashboard/Dashboard";
import MainLayout from "./routes/MainLayout";
import Register from "./pages/register/Register";
import Support from "./pages/support/Support";
import ProfilePage from "./pages/profile/ProfilePage";
import Analytics from "./pages/analytics/Analytics";
import Commission from "./pages/commissions/Commission";
import PersonalInfo from "./pages/profile/pages/PersonalInfo";
import BankDetails from "./pages/profile/pages/BankDetails";
import Leads from "./pages/leads/leads_list/Leads";
import LeadsCreate from "./pages/leads/leads_create/LeadsCreate";
import { ProfileProvider } from "./context/ProfileContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import SupportEmail from "./pages/support/pages/SupportEmail";
import CommonQueriesPage from "./pages/support/pages/CommonQueriesPage";
import SupportTicketCreate from "./pages/support_ticket/support_ticket_create/SupportTicketCreate";
import SupportTicketList from "./pages/support_ticket/support_ticket_list/SupportTicketList";
import { useEffect } from "react";
import { listenNotifications } from "./firebase/FirebaseConfig";
import { ToastContainer } from "react-toastify";
import NotificationsPage from "./pages/push_notification/PushNotification";
import PortfolioList from "./pages/portfolio/portfolio_list/PortfolioList";
import PortfolioPage from "./pages/portfolio/portfolio_data/PortfolioPage";

function App() {
  
    useEffect(() => {
      listenNotifications();
    }, []);

  return (
    <>
     <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/register" element={<Register />} />
       <Route
        element={
          <ProfileProvider>
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          </ProfileProvider>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/supports" element={<Support />} />
        <Route path="/supports/email" element={<SupportEmail />} />
        <Route path="/supports/queries" element={<CommonQueriesPage />} />
        <Route path="/supports/ticket/create" element={<SupportTicketCreate />} />
        <Route path="/supports/ticket/list" element={<SupportTicketList />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/commissions" element={<Commission />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/leads/create" element={<LeadsCreate />} />
        <Route path="/profile/personal-info" element={<PersonalInfo />} />
        <Route path="/profile/bank-details" element={<BankDetails />} />
        <Route path="/push-notification" element={<NotificationsPage />} />
        <Route path="/portfolio-list" element={<PortfolioList />} />
        <Route path="/portfolio-data" element={<PortfolioPage />} />
      </Route>
    </Routes>
    </>
  );
}

export default App;
